import { AppState } from 'Store'
import { createSelector } from 'reselect'
import { getUserRolesSlugsHelper, isShortDataArrayHasSlugHelper } from 'Pages/auth'
import { DigitalConfirmation } from 'Constants/DigitalConfirmation'

const digitalConfirmations = (state: AppState) => state.auth.partner.digital_confirmations
const getUserRoles = (state: AppState) => state.auth?.roles

export const authSelector = {
	partherRbidosStatus: (state: AppState) => state.auth?.partner?.rbidos,
	getUserAliases: (state: AppState) => state.auth?.function_aliases,
	getUserRoles,
	getAuthDataSelector: (state: AppState) => state.auth,
	getUserPartnerIdSelector: (state: AppState) => state.auth?.partner.id,
	isRBIDOSPartnerSelector: (state: AppState) => state.auth?.partner?.rbidos,
	getUserTokenEoSelector: (state: AppState) => state.auth?.eo_token,
	getUserIdSelector: (state: AppState) => state.auth.id,
	getUserTaxationFormSlug: (state: AppState) => state.auth.partner?.taxation_form?.slug,
	getAuthorizedInfotecsSelector: (state: AppState) => state.auth.authorized_to_infotecs,
	getInfotecsToken: (state: AppState) => state.auth.infotecs_token,
	getAuth: (state: AppState) => state.auth,
	getPartnerINN: (state: AppState) => state.auth.partner.vat_number,
	digitalConfirmations,
	isDigitalConfirmationsHasOrders: createSelector(digitalConfirmations, (confirmations) =>
		isShortDataArrayHasSlugHelper(confirmations, DigitalConfirmation.ORDERS)
	),
	isDigitalConfirmationsHasIbro: createSelector(digitalConfirmations, (confirmations) =>
		isShortDataArrayHasSlugHelper(confirmations, DigitalConfirmation.IBRO)
	),
	getUserSlugs: createSelector(getUserRoles, getUserRolesSlugsHelper),
	isUserPartnerMarket: (state: AppState) => state.auth?.partner.market,
	getUserPartnerRate: (state: AppState) => state.auth?.partner.rate,
	getUserPartnerShowActivity: (state: AppState) => state.auth.partner.show_activity,
	getFreeRbidosRequest: (state: AppState) => state.auth?.partner?.free_rbidos_request,
	getUserPartnerSelector: (state: AppState) => state.auth?.partner,
	getServiceSmsConfirmation: (state: AppState) =>
		state.auth?.partner?.permissions?.service_sms_confirmation,
	getSuccessChangePassword: (state: AppState) => state.auth?.isSuccessChangePassword,
	getLeadDistributor: (state: AppState) => state.auth?.is_lead_distributor,
	getId: (state: AppState) => state.auth?.id,
	getDenyBgCommercialDirect: (state: AppState) =>
		state.auth?.partner?.permissions?.deny_bg_commercial_direct,
	getRegistrarCabinetPermissions: (state: AppState) => state.auth?.permissions?.registrar_cabinet,
	getFirstDepartment: (state: AppState) => state.auth?.departments?.[0],
	getDenyBgGoverment: (state: AppState) => state.auth?.partner?.permissions?.deny_bg_government,
	getWorkingWithSubordinateDepartments: (state: AppState) =>
		state.auth?.working_with_subordinate_departments ?? false,
}
